import Logo from './Logo';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-navy py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-10">
          <Logo onDark />
          <nav className="flex flex-wrap gap-8">
            {[
              ['Services', '#services', 'services'],
              ['Who We Serve', '#audiences', 'audiences'],
              ['The Firm', '#about', 'about'],
              ['Our Team', '#team', 'team'],
              ['Contact', '#contact', 'contact'],
            ].map(([label, href, id]) => (
              <a
                key={id}
                href={href}
                data-testid={`footer-link-${id}`}
                className="text-xs tracking-[0.2em] uppercase text-cream/60 transition-colors duration-300 hover:text-gold"
              >
                {label}
              </a>
            ))}
          </nav>
        </div>
        <div className="mt-12 pt-8 border-t border-cream/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-cream/40 font-light tracking-wide">
          <p data-testid="footer-copyright">© {year} A. Grant Mangum &amp; Co., Inc. All rights reserved.</p>
          <p>100 Timberhill Place, Unit 120 · Chapel Hill, NC 27514 · 919-967-5733</p>
        </div>
      </div>
    </footer>
  );
}
